import { BaseResponse } from "../../BaseResponse";
import { CustomerSubscriptionSummaryExtract } from "./CustomerSubscriptionSummaryExtract";
import { NextSubscriptionListEntry } from "./NextSubscriptionListEntry";

export class SubscriptionSummaryResponse extends BaseResponse {
    next: NextSubscriptionListEntry;
    subscriptionSummary: CustomerSubscriptionSummaryExtract;
}